<template>
  <div id="_tlqn_admin_gpm_user_profile" class="full-width" v-if="userProfile">
    <div class="row no-wrap">
      <div class="tlqn-admin-user-profile-avatar-con column items-center">
        <div class="tlqn-admin-user-profile-avatar">
          {{ (userProfile.nickname || "").substr(0, 1) || "/" }}
        </div>

        <q-badge class="q-mt-md q-py-xs q-px-sm" v-if="isLeader">
          组长
        </q-badge>
      </div>

      <div class="column tlqn-admin-user-profile-detail-con">
        <p class="tlqn-admin-user-profile-detail-name">
          {{ userProfile.nickname }}
        </p>
        <p class="tlqn-admin-user-profile-detail-info-item">
          <span class="tlqn-admin-user-profile-detail-info-label">
            联系方式
          </span>
          <span
            class="tlqn-admin-user-profile-detail-info-value"
            v-if="userProfile.phone_number"
          >
            <a :href="userProfile.phone_number">
              {{ userProfile.phone_number }}
            </a>
          </span>
          <span
            class="tlqn-admin-user-profile-detail-info-value tlqn-admin-user-profile-detail-info-value-empty"
            v-else
          >
            未绑定手机号
          </span>
        </p>
        <p>
          <span class="tlqn-admin-user-profile-detail-info-label">
            问题问卷
          </span>
          <span class="tlqn-admin-user-profile-detail-info-value"> 0</span>
        </p>
        <div class="row items-center tlqn-admin-user-profile-detail-action">
          <q-btn
            flat
            :disable="isLeader"
            class="q-mr-sm"
            :class="{
              'tlqn-aupda-disable': isLeader,
            }"
            @click="applyLeader"
          >
            {{ isLeader ? "已是组长" : "设为组长" }}
          </q-btn>
          <q-btn
            flat
            :disable="!isLeader"
            :class="{
              'tlqn-aupda-disable': !isLeader,
            }"
            @click="removeLeader"
          >
            {{ !isLeader ? "已是访员" : "设为访员" }}
          </q-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { applyGroupLeaderRole } from "../../../../api/endpoints/user/applyGroupLeaderRole";
import { GROUP_MEMBER_DETAIL_CHANGE } from "@/bus/admin.events";
import { EventBus } from "@/bus/index";
import { removeGroupLeaderRole } from "../../../../api/endpoints/user/removeGroupLeaderRole";
export default {
  props: {
    userProfile: {
      default: () => ({}),
    },
  },

  data() {
    return {
      loading: false,
    };
  },

  computed: {
    isLeader() {
      const { userProfile } = this;
      return (
        userProfile &&
        userProfile.roles &&
        userProfile.roles.some((r) => r.value === "002")
      );
    },

    userId() {
      return this.userProfile.id;
    },
  },

  watch: {
    userProfile: {
      immediate: true,
      deep: true,
      handler() {
        console.log(this.userProfile)
      }
    }
  },

  methods: {
    /**
     * 赋予当前用户组长
     */
    async applyLeader() {
      this.loading = true;
      try {
        const res = await applyGroupLeaderRole({ id: this.userId });
        if (res.status || res.error) {
          this.$q.notify({
            type: "danger",
            message: res.detail || res.message,
          });
        } else {
          this.$q.notify({
            type: "success",
            message: "已设置为组长",
          });
          this.$emit("updated", "");
          EventBus.$emit(GROUP_MEMBER_DETAIL_CHANGE);
        }
      } catch (err) {
        console.log(err);
        this.$q.notify({ type: "danger", message: "设为组长时发生未知错误" });
      }
    },

    /**
     * 移除当前用户的组长权限
     */
    async removeLeader() {
      this.loading = true;
      try {
        const res = await removeGroupLeaderRole({ id: this.userId });
        if (res.status || res.error) {
          this.$q.notify({
            type: "danger",
            message: res.detail || res.message,
          });
        } else {
          this.$q.notify({
            type: "success",
            message: "已设置为访员",
          });
          this.$emit("updated", "");
          EventBus.$emit(GROUP_MEMBER_DETAIL_CHANGE);
        }
      } catch (err) {
        console.log(err);
        this.$q.notify({ type: "danger", message: "设置为访员时发生未知错误" });
      }
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/quasar";

#_tlqn_admin_gpm_user_profile {
}

/* 头像 */
.tlqn-admin-user-profile-avatar-con {
  padding: 20px;
  max-width: 300px;
  width: 50%;
  /* background-color: rebeccapurple; */
}
.tlqn-admin-user-profile-avatar {
  width: 120px;
  height: 120px;
  border-radius: 50px;
  background-color: rgba($primary, 0.3);
  color: $primary;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 3rem;
}

.tlqn-admin-user-profile-detail-con {
  padding: 20px 0;
}
.tlqn-admin-user-profile-detail-name {
  font-size: 1.5rem;
  font-weight: bold;
}
.tlqn-admin-user-profile-detail-info-label {
  font-weight: bold;
  margin-right: 20px;
  &::after {
    content: ":";
  }
}
.tlqn-admin-user-profile-detail-info-value-empty {
  color: $grey;
}
.tlqn-admin-user-profile-detail-action {
  & > button {
    background-color: $primary;
    color: #fff;
  }
  & > button.tlqn-aupda-disable {
    background-color: rgba($primary, 0.1);
    color: $primary;
    margin-right: 10px;
  }
}
</style>
